import { LOGIN_REQUEEST, LOGOUT_REQUEEST } from "../constants/action-types";

// Reducer to add article
const initilState = {
  token: "",
};

const authReducer = (state = initilState, action) => {
  switch (action.type) {
    case LOGIN_REQUEEST:
      return {
        ...state,
        token: action.payload,
      };
    case LOGOUT_REQUEEST:
      return {
        ...state,
        token: "",
      };
    default:
      return state;
  }
};

export default authReducer;
